
import { USER_AUD_PREFERENCES_PATH, USER_LANGUAGE_PREFERENCES } from '../paths';
import { getProfileLastTouch } from '../../../../utils/Socialization';
import { apiCall } from '../../..';

export const languagePreferecesService = async ({ userToken }) => {
  return await apiCall.get(`${USER_LANGUAGE_PREFERENCES}`, {
    baseURL: `${process.env.URL_DOMINIO_MICROFWK}`,
    params: {
      lasttouch: getProfileLastTouch(),
    },
  });
};

export const getAudPreferencesService = async ({ group_id }) => {
  return await apiCall.get(USER_AUD_PREFERENCES_PATH, {
    params: { group_id },
  });
};
